<template>

    <div>

        <div class="heading" v-if="title">
            <h2 class="mb-3 mb-lg-5">{{ title }}</h2>
        </div>

<!--     @todo   <ul class="nav nav-pills mb-4">
            <li class="nav-item">
                <a class="nav-link active" aria-current="page" href="#">Neuheiten</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#">Topseller</a>
            </li>
            <li class="nav-item">
                <a class="nav-link" href="#">Beliebt</a>
            </li>
        </ul>-->

        <!--<div class="mt-4 mb-4 d-flex justify-content-between">
            <h2>{{ $title }}</h2>
            <ul class="nav">
                <li class="nav-item">
                    <a class="nav-link active" href="#">Active</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Link</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" href="#">Link</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link disabled" href="#" tabindex="-1" aria-disabled="true">Disabled</a>
                </li>
            </ul>
        </div>-->
    </div>

</template>


<script>
    export default {
        props: [
            'title',
        ],
        data() {
            return {

            }
        }
    }
</script>